<span [matBadgeHidden]="!(showZero ? alertCount >= 0 : alertCount && alertCount > 0)"
      [matBadge]="alertCount || ''"
      matBadgePosition="after"
      matBadgeOverlap="false"
      [ngClass]="alertColor">{{text || '&nbsp;'}}</span>
